module.exports = __webpack_public_path__ + "img/add.ba325a1f.svg";